module.exports = function() {
  return new Worker(__webpack_public_path__ + "7df25c5684e1420272a3.worker.js");
};